import * as React from 'react'

function SvgArrow(props) {
  return (
    <svg
      width={16}
      height={8}
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 4H1M4 1L1 4l3 3"
        stroke="#317AEC"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgArrow
